import { UserInformation } from "../../interfaces";

import userHelper from "../userHelper";

export interface UserInfo {
    empresa:    string;
    sucursal:   string;
    nivt:       string | undefined;
    nivc:       string | undefined;
    nit1:       string | undefined;
    niv1:       string | undefined;
}

export const getUserInfo = (): UserInfo => {
    const { codigoDeEmpresa, codigoDeSucursal, intermediarioPrincipal, intermediarioSecundario }: UserInformation = userHelper.getUser()!

    return {
        empresa: codigoDeEmpresa,
        sucursal: codigoDeSucursal,
        nivt: intermediarioSecundario?.nivelInter,
        nivc: intermediarioSecundario?.codigoInter,
        nit1: intermediarioPrincipal?.nivelInter,
        niv1: intermediarioPrincipal?.codigoInter,
    };
};

export interface UserInfoAlter {
    empr:    string;
    sucu:   string;
    nivt:       string | undefined;
    nivc:       string | undefined;
    nit1:       string | undefined;
    niv1:       string | undefined;
}

export const getUserInfoAlter = (): UserInfoAlter => {
    const { codigoDeEmpresa, codigoDeSucursal, intermediarioPrincipal, intermediarioSecundario }: UserInformation = userHelper.getUser()!

    return {
        empr: codigoDeEmpresa,
        sucu: codigoDeSucursal,
        nivt: intermediarioSecundario?.nivelInter,
        nivc: intermediarioSecundario?.codigoInter,
        nit1: intermediarioPrincipal?.nivelInter,
        niv1: intermediarioPrincipal?.codigoInter,
    };
};